// This file is generated by pnpm icons:generate. Do not edit.

import {FilterTimeline_Stroke2_Corner0_Rounded as CanonicalFilterTimeline_Stroke2_Corner0_Rounded} from './Filter'

/** @deprecated Import FilterTimeline_Stroke2_Corner0_Rounded from `#/components/icons/Filter` instead. */
export const FilterTimeline_Stroke2_Corner0_Rounded =
  CanonicalFilterTimeline_Stroke2_Corner0_Rounded
